import apiClient from '../index';

const smsApi = {
  // Get all SMS credits
  getSmsCredits: () => apiClient.get('/messaging'),
  
  // Create new SMS credit entry
  createSmsCredit: (data) => apiClient.post('/messaging', data),
  
  // Get single SMS credit
  getSmsCredit: (sms_credit_id) => apiClient.get(`/messaging/${sms_credit_id}`),
  
  // Update SMS credit
  updateSmsCredit: (sms_credit_id, data) => apiClient.put(`/messaging/${sms_credit_id}`, data),
  
  // Delete SMS credit
  deleteSmsCredit: (sms_credit_id) => apiClient.delete(`/messaging/${sms_credit_id}`),
  
  // Get event-specific SMS and WhatsApp credits
  getEventCredits: () => apiClient.get('/messaging/event-credits'),
  
  // Get SMS history
  getSmsHistory: (eventId = null, params = {}) => {
    const queryParams = eventId ? { ...params, event_id: eventId } : params;
    return apiClient.get('/messaging/sms-history', { params: queryParams });
  },
  
  // SMS top-up
  topUpSms: (data) => apiClient.post('/messaging/top-up', data),
  
  // Get SMS delivery status
  getSmsDeliveryStatus: (params = {}) => apiClient.get('/messaging/delivery', { params }),
  
  // Resend SMS
  resendSms: (messageId) => apiClient.post(`/messaging/resend/${messageId}`)
};

export default smsApi;
